// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlackSquareFilledSvg from "@ant-design/icons-svg/es/asn/SlackSquareFilled";
import AntdIcon from '../components/AntdIcon';

var SlackSquareFilled = function SlackSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlackSquareFilledSvg
  }));
};

SlackSquareFilled.displayName = 'SlackSquareFilled';
export default React.forwardRef(SlackSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SlackSquareFilled.js
// module id = 1825
// module chunks = 0